import Component from '@glimmer/component';
import { service } from '@ember/service';
import { array } from '@ember/helper';
import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import PartnerReportsPage from 'tio-reporting/components/partner-reports-page';
import { Section, VStack } from 'tio-ui/components/layout';
import type SessionContextService from 'tio-employee/services/session-context';

interface S {
  Args: {
    model: {
      id: string;
    };
  };
}

class ReportingIndexRoute extends Component<S> {
  @service declare sessionContext: SessionContextService;

  get companyId() {
    return this.sessionContext.currentRole?.company.id;
  }

  <template>
    {{pageTitle (t "reporting.reports")}}
    <VStack>
      {{#if this.companyId}}
        <Section>
          <:header>{{t "reporting.reports"}}</:header>
          <:body>
            {{! Partner launch scope: TAS reports only for now — other product
                types (syf, pslf, slr, dashboards) stay admin-side even when
                published, until each product is cleared for partner rollout. }}
            <PartnerReportsPage
              @companyId={{this.companyId}}
              @viewerRoute="authenticated.admin.reporting.report-viewer"
              @reportTypes={{array "tas"}}
            />
          </:body>
        </Section>
      {{/if}}
    </VStack>
  </template>
}

export default ReportingIndexRoute;
